import { getCapabilityById } from "../content/offerings/services";
import { getProductById } from "../content/offerings/products";
import {
  SERVICE_CAPABILITY_TO_WIZARD,
  SERVICE_PRODUCT_TO_WIZARD,
  WIZARD_SERVICES,
  type WizardServiceId,
} from "../content/projectWizard";

export type WizardEntry = {
  offeringKind: "product" | "capability" | null;
  offeringId: string | null;
  offeringTitle: string | null;
  wizardServices: WizardServiceId[];
  /** Skip “what do you need” when opened from a product/service page */
  skipServicesStep: boolean;
};

export function wizardProductHref(productId: string): string {
  return `/start-project?product=${encodeURIComponent(productId)}`;
}

export function wizardCapabilityHref(capabilityId: string): string {
  return `/start-project?service=${encodeURIComponent(capabilityId)}`;
}

export function wizardOfferingHref(
  kind: "product" | "capability",
  id: string,
): string {
  return kind === "product" ? wizardProductHref(id) : wizardCapabilityHref(id);
}

export function resolveWizardEntry(
  productParam: string | null,
  serviceParam: string | null,
): WizardEntry {
  if (productParam) {
    const product = getProductById(productParam);
    let wizardServices: WizardServiceId[] = [];

    if (productParam === "mobile-app") {
      wizardServices = ["ios-app", "android-app"];
    } else {
      const mapped = SERVICE_PRODUCT_TO_WIZARD[productParam];
      if (mapped) wizardServices = [mapped];
    }

    return {
      offeringKind: "product",
      offeringId: productParam,
      offeringTitle: product?.title ?? productParam,
      wizardServices,
      skipServicesStep: wizardServices.length > 0,
    };
  }

  if (serviceParam) {
    const capability = getCapabilityById(serviceParam);
    const wizardServices = SERVICE_CAPABILITY_TO_WIZARD[serviceParam] ?? [];
    return {
      offeringKind: "capability",
      offeringId: serviceParam,
      offeringTitle: capability?.title ?? serviceParam,
      wizardServices,
      skipServicesStep: wizardServices.length > 0,
    };
  }

  return {
    offeringKind: null,
    offeringId: null,
    offeringTitle: null,
    wizardServices: [],
    skipServicesStep: false,
  };
}

export function wizardServiceLabels(ids: WizardServiceId[]): string[] {
  return ids.map((id) => WIZARD_SERVICES.find((s) => s.id === id)?.title ?? id);
}
